import { css, Theme } from "@emotion/react";

export const root = (highlighted: boolean) => (theme: Theme) =>
    css({
        verticalAlign: "baseline",
        display: "inline-block",
        lineHeight: "28px",

        ...(highlighted
            ? {
                  "span > label > span": {
                      borderColor: theme.candy.valueControls.highlightedBorderColor,
                      borderRadius: "1px",
                      boxShadow: `0 0 0 1px ${theme.candy.valueControls.highlightedBorderColor}`,
                  },
              }
            : {}),
    });
